import PropTypes from 'prop-types';

const FormBtn = ({ onClick, name, customClass, svgIcon }) => {
  return (
    <button
      type="button"
      className={`relative z-10 table uppercase font-primary bg-black text-white p-3 lg:p-[1vw] 
        text-xs sm:text-sm lg:text-[0.938vw] overflow-hidden tracking-widest cta ease-in-out duration-500 !leading-[1] ${customClass ? customClass : ""
        }`}
      onClick={onClick}
    >
      {svgIcon && <span className="icon">{svgIcon}</span>}
      {name}
    </button>
  );
};

FormBtn.propTypes = {
  onClick: PropTypes.func,
  name: PropTypes.string.isRequired,
  customClass: PropTypes.string,
  svgIcon: PropTypes.element,
};

export default FormBtn;
